import React from 'react';
import {MyDate} from "../dates/util";

export const name = "The Willpower Instinct";
export const created_on = new MyDate(2019, 2, 10);

export const mod = () => {
    return (
        <>
            <p>
                Of late I've started reflecting on what my professional
                life has been upto and how have I been holding up here.
                My latest self-evaluation is that "I'm just fine".
            </p>
            <p>
                <em>Good. But not good enough.</em>
            </p>
            <p>
                I've recently started thinking of
                (<em>debugging the core dump!</em>) what excited me about
                being a coder when I took programming 101 classes back in
                my middle school & how random programming assignments
                enthralled me. They enthral me even today. But what
                surrounds programming in my day-to-day life now has a few
                moments which are not exciting at all. Typing up them
                reports; explaining myself; prioritizing non-exciting
                work to meet deadlines. This is definitely not what I
                had thought I'll be doing to employ my skills as a programmer.
                Yes it pays, quite a <em>lot</em> to be honest. Yes, as
                a kid I didn't imagine that what excites me today will
                pay a lot tomorrow.
            </p>
            <p>
                <em>Looking for thrill.</em> Like every time I felt when I
                stepped inside those computer labs back in college<b>;</b> back
                in intermediate<b>;</b> back in high school<b>;</b> back in middle school.
                I read somewhere that being a student of liberal arts makes
                one creative. So I took
                up <a href="https://www.goodreads.com/user/show/18624313-prabodh-agarwal"><span>reading</span></a>.
            </p>
            <p>
                "<em>Willpower Instinct</em>". I hope to read this and find
                a way out to get back to the exciting part of being a coder;
                of being a computer science enthusiast. The book's intro
                chapter talks about there being assignments. <em>duh!</em>
                I'll try to blog about how have I been doing on those assignments
                here.
            </p>
        </>
    );
}
